export const dtIdentifyUser = id => {
  if (window.dtrum) {
    window.dtrum.identifyUser(id);
  }
};
